import { render, staticRenderFns } from "./client-request.component.vue?vue&type=template&id=c04b5252"
import script from "./client-request.component.ts?vue&type=script&lang=ts&external"
export * from "./client-request.component.ts?vue&type=script&lang=ts&external"
import style0 from "./client-request.style.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
